export enum CrisRequestType {
    /**
     * Correction patterns (store map/unmap)
     */
    STORE = 'str',
    /**
     * Channel patterns (set online/b&m)
     */
    CHANNEL = 'chn',
    /**
     * Location patterns (extract store numbers)
     */
    LOCATION = 'loc',
}
